import { createAction, handleActions } from 'redux-actions';
import { _getWaiverOfLiabilityConfigurationInfo, _updateWaiverOfLiabilityConfigurationInfo } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';
import {getFormData} from "../../../shared/utils/formData";

const initialState = {
    waiver_of_liability_configuration_info: { loading: false, response: [], hasError: false, error: {} },
};
//WAIVER_OF_LIABILITY_CONFIGURATION_INFO LIST
export const getWaiverOfLiabilityConfigurationInfoStart = createAction(ActionTypes.GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO);
export const getWaiverOfLiabilityConfigurationInfoSuccess = createAction(ActionTypes.GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_SUCCESS, response => response);
export const getWaiverOfLiabilityConfigurationInfoError = createAction(ActionTypes.GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_ERROR, error => error);

export const getWaiverOfLiabilityConfigurationInfo = () => (dispatch) => {
    dispatch(getWaiverOfLiabilityConfigurationInfoStart());
    return _getWaiverOfLiabilityConfigurationInfo().then((response) => {
        dispatch(getWaiverOfLiabilityConfigurationInfoSuccess(response));
    }).catch((error) => {
        dispatch(getWaiverOfLiabilityConfigurationInfoError(error));
    });
};

//UPDATE WAIVER_OF_LIABILITY_CONFIGURATION_INFO
export const updateWaiverOfLiabilityConfigurationInfoStart = createAction(ActionTypes.UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO);
export const updateWaiverOfLiabilityConfigurationInfoSuccess = createAction(ActionTypes.UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_SUCCESS, response => response);
export const updateWaiverOfLiabilityConfigurationInfoError = createAction(ActionTypes.UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_ERROR, error => error);

export const updateWaiverOfLiabilityConfigurationInfo = (data) => (dispatch) => {
    let formdata = getFormData(data)
    dispatch(updateWaiverOfLiabilityConfigurationInfoStart());
    return _updateWaiverOfLiabilityConfigurationInfo(formdata).then((response) => {
        dispatch(updateWaiverOfLiabilityConfigurationInfoSuccess(response));
    }).catch((error) => {
        dispatch(updateWaiverOfLiabilityConfigurationInfoError(error));
    });
};

const reducer = handleActions({
    //WAIVER_OF_LIABILITY_CONFIGURATION_INFO_LIST
    [ActionTypes.GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO]: (state) => ({
        ...state, waiver_of_liability_configuration_info: {
            ...state.waiver_of_liability_configuration_info,
            loading: true, hasError: false, error: {}
        },
    }),
    [ActionTypes.GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_SUCCESS]: (state, action) => (
        {
            ...state,
            waiver_of_liability_configuration_info: {
                ...state.waiver_of_liability_configuration_info,
                response: action.payload, loading: false, hasError: false, error: {}
            },
        }),
    [ActionTypes.GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_ERROR]: (state, action) => ({
        ...state,
        waiver_of_liability_configuration_info: {
            ...state.waiver_of_liability_configuration_info,
            error: action.payload, loading: false, hasError: true, response: {}
        },
    }),
    //UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO
    [ActionTypes.UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO]: (state) => ({
        ...state,
        waiver_of_liability_configuration_info: {
            ...state.waiver_of_liability_configuration_info,
            loading: true, hasError: false, error: {}
        },
    }),
    [ActionTypes.UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_SUCCESS]: (state, action) => ({
        ...state,
        waiver_of_liability_configuration_info: {
            ...state.waiver_of_liability_configuration_info,
            response: action.payload,
            loading: false, hasError: false, error: {}
        },
    }),
    [ActionTypes.UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_ERROR]: (state) => ({
        ...state,
        waiver_of_liability_configuration_info: {
            ...state.waiver_of_liability_configuration_info,
            loading: false, hasError: true, error: {}
        },
    })

}, initialState);

export default reducer;
